<template>
    <el-dialog title="Actualizar Información de Contacto y del Servicio"
        :visible="showDialog"
        @close="close"
        width="45%"
        @open="create"
    >
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Nombre
                    </label>
                    <el-input v-model="form.contact_name"></el-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Correo
                    </label>
                    <el-input v-model="form.contact_email"></el-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Número de Whatsapp
                    </label>
                    <el-input v-model="form.contact_whatsapp"></el-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Plan
                    </label>
                    <el-select
                        v-model="form.plan_id"
                    >
                        <el-option
                            v-for="option in arrayPlans"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id"
                            :disabled="!option.active">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Precio
                    </label>
                    <el-input v-model="form.price"></el-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="control-label">
                        Periodo
                    </label>
                    <el-select v-model="form.period_id" placeholder="Selecciona un periodo">
                        <el-option v-for="(period, index) in periods"
                            :key="index"
                            :label="period.name"
                            :value="period.id"
                        ></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="form-actions text-right pt-2">
            <el-button type="primary"
                @click="submit"
                :loading="loading_submit"
            >
                Guardar
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            showDialog: {
                type: Boolean,
                default: false
            },
            recordId: {
                type: String,
                default: null
            }
        },

        computed: {
            arrayPlans() {
                let plans = this.plans.filter(plan => plan.active)
                if (this.recordId) {
                    const planSelected = this.plans.filter(plan => plan.id === this.form.plan_id)
                    if (planSelected.length) {
                        plans.push(planSelected[0])
                    }
                }
                const seen = new Set()
                return plans.filter(p => (seen.has(p.id) ? false : (seen.add(p.id), true)));
            }
        },

        data() {
            return {
                form: {
                    contact_name: null,
                    contact_email: null,
                    contact_whatsapp: null,
                    plan_id: null,
                    period_id: null,
                    price: null,
                },
                plans: [],
                periods: [],
                loading_submit: false,
            }
        },

        async created() {
            await this.loadInfo()
        },

        methods: {
            close() {
                this.form = {
                    contact_name: null,
                    contact_email: null,
                    contact_whatsapp: null,
                    plan_id: null,
                    period_id: null,
                    price: null,
                }
                this.$emit('update:showDialog', false)
            },

            async loadInfo() {
                try {
                    const { data } = await this.$http.get('/client-payments/info')
                    this.plans = data.plans
                    this.periods = data.periods
                } catch (error) {
                    
                }
            },

            async create() {
                try {
                    const { data } = await this.$http.get(`/client-payments/client-contact/${this.recordId}`)
                    if (data.success) {
                        Object.assign(this.form, data.data)
                    }
                } catch (error) {
                    
                }
            },

            async submit() {
                try {
                    this.loading_submit = true
                    const { data } = await this.$http.post(`/client-payments/client-contact/${this.recordId}`, this.form)
                    if (data.success) {
                        this.$message.success(data.message)
                        this.close()
                        this.$emit('updated')
                    }
                } catch (error) {
                    const message = error.response.data.message || 'Error al realizar la operación'
                    this.$message.error(message)
                } finally {
                    this.loading_submit = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/payments/components/form-contact.vue